"use client";
import DashboardWrapper from "../src/components/dashboard-wrapper";
export default function DashboardPage() {
    return (
        <>
        <DashboardWrapper />
        </>
    );
}
